// extracted by mini-css-extract-plugin
module.exports = {"component":"Tooltip_component__1v-qw","info":"Tooltip_info__3tdPW","content":"Tooltip_content__21Eof"};